import Vue from 'vue'
import VueI18n from 'vue-i18n'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
import _import from './_import';
import enLocale from './en'
import zhLocale from './zh'
import twLocale from './tw'
import jpLocale from './jp'

Vue.use(VueI18n);

const messages = {
    'en-US': {
        ...enLocale,
        ...elementEnLocale,
        ..._import["en"],
    },
    'zh-CN': {
        ...zhLocale,
        ...elementZhLocale,
        ..._import["zh"],
    },
    'zh-TW': {
        ...twLocale,
        ...elementZhLocale,
        ..._import["tw"],
    },
    'ja-JP': {
        ...jpLocale,
        ...elementZhLocale,
        ..._import["jp"],
    }
};

function getUrlkey() {
  let url = window.location.href;  
  var params = {};
  var urls = url.split("?");
  var arr =  urls[1] ? urls[1].split("&") : [];
  for (var i = 0, l = arr.length; i < l; i++) {
    var a = arr[i].split("=");
    params[a[0]] = a[1]; 
  }
  return params;
}

// setting sessionStorage.langType Value
let langDefault = getUrlkey().lang ? getUrlkey().lang.substring(0,5) && (sessionStorage.langType = getUrlkey().lang.substring(0,5))
                  :getUrlkey().langType;

let lang = getUrlkey().langType ? getUrlkey().langType.substring(0,5) &&  (sessionStorage.langType = getUrlkey().langType.substring(0,5))
         : sessionStorage.getItem('langType') ? sessionStorage.getItem('langType') 
         : 'en-US' && (sessionStorage.langType = 'en-US');

const i18n = new VueI18n({
    locale: lang, // set locale
    messages // set locale messages
});

export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js